import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button, colors, Box } from '@material-ui/core';
import { SectionHeader, IconAlternate } from 'components/molecules';
import { DescriptionListIcon } from 'components/organisms';

const Services = props => {
  const { data, className, ...rest } = props;

  return (
    <div className={className} data-aos="fade-up" {...rest}>
      <SectionHeader
        title={<span><span style={{ color: 'rgb(255,100,83)' }}>Key</span> features</span>}
        subtitle="We continously work on new features that improve experience."
        subtitleProps={{
          variant: 'body1',
          color: 'textSecondary'
        }}
        ctaGroup={[<Box mb={2}></Box>]}
        fadeUp
      />
      <Grid container spacing={7}>
        {data.map((item, index) => (
          <Grid
            key={index}
            item
            container
            alignItems="center"
            direction="column"
            xs={12}
            sm={6}
            md={4}
            data-aos="fade-up"
          >
            <DescriptionListIcon
              icon={
                <IconAlternate
                  fontIconClass={item.icon}
                  color={colors.indigo}
                />
              }
              title={item.title}
              subtitle={item.description}
              align="left"
            />
          </Grid>
        ))}
        <Grid item container xs={12} justify="center">
          <Box mt={4}>
          <Button variant="outlined" size="large" color="secondary" href="https://inventory-backoffice.qeerio.com">
            Get started now
            </Button>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

Services.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * data to be rendered
   */
  data: PropTypes.array.isRequired,
};

export default Services;
